import { ReactNode, useEffect } from 'react'

/**
 * Base "gtag" function for Google Analytics
 * @docs https://developers.google.com/analytics/devguides/collection/gtagjs/events
 * @example gtag('event', 'sign_in', { 'admin': 'true' });
 * @example gtag('config', <GA_ID>);
 */
export function gtag(..._args: any[]) {
  window.dataLayer = window.dataLayer || []
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments)
}

/**
 * Component to inject Google Analytics code into DOM
 */
export const BeamGoogleAnalytics = ({ children }: { children?: ReactNode }) => {
  useEffect(function setupGoogleAnalyticsOnMount() {
    // Update the following variable to tailor to your local GA account
    // (it would be noisy if we're all hitting the same instance)
    const ga_tracking_id =
      process.env.REACT_APP_GA_TRACKING_ID ||
      window.location.hostname === 'partner-portal.beamimpact.com'
        ? 'G-P1Y67G1HCS' // Production only
        : 'G-NLJ0H2B1H1' // For all environments

    if (window.location.hostname.includes('localhost')) {
      return
    }

    const scriptSrc = `https://www.googletagmanager.com/gtag/js?id=${ga_tracking_id}`

    const existingScript = document.querySelector(`script[src="${scriptSrc}"]`)
    if (existingScript) {
      return // do not set up GA twice
    }

    const script = document.createElement('script')
    script.src = scriptSrc
    script.async = true
    document.head.appendChild(script)

    gtag('js', new Date())

    gtag('config', ga_tracking_id)
  }, [])

  return <>{children}</>
}
